import { __assign, __read, __rest } from "tslib";
import React, { forwardRef, useImperativeHandle, useRef, useState, } from 'react';
import { useForkRef, useTheme, useThemeProps, } from '../../../foundation';
import { getTransitionProps, reflow, setTransitionStyle, Transition, } from '../../Transitions';
import { useNormalizedTransitionProps } from '../../Transitions/utils';
import { getHighlightStyle } from './utils';
/**
 * provide transition for highlight element,
 * default behaviors: highlight for `1s` then transition to non background with `2s`
 */
var RcHighlight = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcHighlight' });
    var children = props.children, style = props.style, onExit = props.onExit, onEnter = props.onEnter, onExited = props.onExited, backgroundColorProp = props.backgroundColor, _a = props.duration, duration = _a === void 0 ? 3000 : _a, _b = props.holdTime, holdTime = _b === void 0 ? 1000 : _b, _c = props.easing, easing = _c === void 0 ? 'cubic-bezier(.575, .105, .835, .295)' : _c, action = props.action, other = __rest(props, ["children", "style", "onExit", "onEnter", "onExited", "backgroundColor", "duration", "holdTime", "easing", "action"]);
    var theme = useTheme();
    var _d = __read(useState(false), 2), inValue = _d[0], setInValue = _d[1];
    var styles = getHighlightStyle({ backgroundColorProp: backgroundColorProp, theme: theme });
    var nodeRef = useRef(null);
    var handlers = useNormalizedTransitionProps(__assign(__assign({}, props), { onEnter: function (node, isAppearing) {
            reflow(node); // So the animation always start from the start.
            setTransitionStyle(node, '');
            onEnter === null || onEnter === void 0 ? void 0 : onEnter(node, isAppearing);
        }, onExit: function (node) {
            var transitionProps = getTransitionProps({
                style: { transitionDelay: holdTime + "ms" },
                timeout: { exit: duration - holdTime },
                easing: easing,
            }, {
                mode: 'exit',
            });
            var transitionStyle = theme.transitions.create(['background-color'], transitionProps);
            setTransitionStyle(node, transitionStyle);
            onExit === null || onExit === void 0 ? void 0 : onExit(node);
        }, onExited: function (node) {
            setTransitionStyle(node, '');
            onExited === null || onExited === void 0 ? void 0 : onExited(node);
        } }), nodeRef);
    var foreignRef = useForkRef(children.ref, ref);
    var handleRef = useForkRef(nodeRef, foreignRef);
    useImperativeHandle(action, function () { return function () {
        setInValue(true);
        setTimeout(function () { return setInValue(false); }, 0);
    }; }, []);
    return (React.createElement(Transition, __assign({ appear: true, nodeRef: nodeRef, in: inValue }, handlers, other, { timeout: { exit: duration } }), function (state, childProps) {
        return React.cloneElement(children, __assign({ style: __assign(__assign(__assign({}, style), children.props.style), styles[state]), ref: handleRef }, childProps));
    }));
});
RcHighlight.defaultProps = {};
RcHighlight.displayName = 'RcHighlight';
export { RcHighlight };
